import { BaseModel } from './base';

export class SlicklineType extends BaseModel {
  SlicklineTypeName: string;

  subscriberId: string;
  siteId: string;
  id: string;
}
